import { CallTrackingContext } from '../context'
import { useContext } from 'react'

export function useCallTrackingContext() {
  const context = useContext(CallTrackingContext)

  if (context === undefined)
    throw Error('Must be descendant of CallTrackingContextProvider')

  return context
}
